import { render, staticRenderFns } from "./appSellerDashboard.vue?vue&type=template&id=3283b874"
import script from "./appSellerDashboard.vue?vue&type=script&lang=js"
export * from "./appSellerDashboard.vue?vue&type=script&lang=js"
import style0 from "./appSellerDashboard.vue?vue&type=style&index=0&id=3283b874&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports